<script setup>
import PictureLazy from '@maison/components/common/PictureLazy.vue';
import { computed } from 'vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  image: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  lightboxId: {
    type: String,
    default: null,
  },
  pictureClasses: {
    type: String,
    default: 'picture',
  },
  slideClasses: {
    type: String,
    default: '',
  },
});

const hasLightbox = computed(() => props.lightboxId !== null);
</script>

<template>
  <div :id="id" :class="['slider__item', slideClasses]" role="tabpanel" :aria-labelledby="`pagination-${index + 1}`">
    <div
      :class="pictureClasses"
      :data-lightbox-open="hasLightbox ? lightboxId : null"
      :data-lightbox-index="hasLightbox ? index : null"
    >
      <picture-lazy v-bind="image" />
    </div>
  </div>
</template>
